var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{class:{
    'shadow-card': true,
    'clickable': _vm.clickable
  },style:({ 'width': _vm.coverWidth }),attrs:{"body-style":{ 
    'padding': 0,
    'height': !_vm.hasSlot('content') ? _vm.coverHeight : '100%'
  },"oncontextmenu":"return false;"}},[(_vm.coverSrc)?_c('img',{staticClass:"image",style:({ 'width': _vm.coverWidth, 'height': _vm.coverHeight }),attrs:{"src":_vm.coverSrc,"draggable":"false"}}):_vm._e(),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }